<pre class="m-5">{{buildInfo | json}}</pre>
